var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9421 15.0031H19.6549","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Minus.defaultProps = {"viewBox":"0 0 30 30","fill":"none"};

module.exports = Minus;

Minus.default = Minus;
